import Box from '@amzn/awsui-components-react/polaris/box';
import ColumnLayout from '@amzn/awsui-components-react/polaris/column-layout';
import Container from '@amzn/awsui-components-react/polaris/container';
import Header from '@amzn/awsui-components-react/polaris/header';
import { EventEngineEventsService } from '@amzn/event-engine-events-sdk';
import { getDisplayValue, ValueWithLabel } from '@amzn/event-engine-js-utils';
import { differenceInHours, format, formatDistanceStrict } from 'date-fns';
import React, { FC } from 'react';
import { i18nStrings } from 'utils/constants';

interface EventInformationContainerProps {
    eventData: EventEngineEventsService.ParticipantGetEventResponse;
}

const EventInformationContainer: FC<EventInformationContainerProps> = ({
    eventData,
}) => (
    <Container
        header={
            <Header variant="h2">
                {i18nStrings.event.headers.eventInformation}
            </Header>
        }
        footer={
            <Box padding={{ vertical: 'xs' }}>
                <ValueWithLabel label={i18nStrings.event.labels.description}>
                    {eventData.description}
                </ValueWithLabel>
            </Box>
        }>
        <ColumnLayout columns={4} variant="text-grid">
            <ValueWithLabel label={i18nStrings.event.labels.startTime}>
                {format(eventData.startTime, 'M/dd/yyyy hh:mm a')}
            </ValueWithLabel>
            <ValueWithLabel label={i18nStrings.event.labels.duration}>
                {formatDistanceStrict(eventData.endTime, eventData.startTime, {
                    unit: 'hour',
                })}
            </ValueWithLabel>
            <ValueWithLabel label={i18nStrings.event.labels.accessibleRegions}>
                {getDisplayValue(eventData.accessibleRegions, {
                    defaultValue: i18nStrings.emptyValue,
                })}
            </ValueWithLabel>
        </ColumnLayout>
    </Container>
);

export default EventInformationContainer;
